export const Logo = require('../assets/image/logo.png');
export const LogoFull = require('../assets/image/logo-meet-easy.png');
export const LogoLigth = require('../assets/image/logo-meeteasy-ligth.png');
export const LogoImageUserDefault = require('../assets/image/default-images.jpg');
export const EmptyDataImage = require('../assets/image/empty-data.png');